import {
  PostVerificarDocumentoTitular,
  GetIdentificacionTitularExtranjero
} from "../../../reducers/personaReferencia";

export interface VerificarDocumentoTitularStore
  extends PostVerificarDocumentoTitular,
    GetIdentificacionTitularExtranjero {}

export const verificarDocumentoTitularStore: (
  state
) => VerificarDocumentoTitularStore = state => {
  const { personaReferencia } = state;
  return {
    verificacionDocumentoTitular:
      personaReferencia.verificacionDocumentoTitular,
    postingVerificarDocumentoTitular:
      personaReferencia.postingVerificarDocumentoTitular,
    postingVerificarDocumentoTitularError:
      personaReferencia.postingVerificarDocumentoTitularError,
    identificacionTitularExtranjero:
      personaReferencia.identificacionTitularExtranjero,
    gettingIdentificacionTitularExtranjero:
      personaReferencia.gettingIdentificacionTitularExtranjero,
    gettingIdentificacionTitularExtranjeroError:
      personaReferencia.gettingIdentificacionTitularExtranjeroError
  };
};
